import { Filter } from '@loopback/filter';
import { api } from 'api/api';
import { ConstellationResult } from 'shared/model/ConstellationResult.model';

export const extendedApi = api
  .enhanceEndpoints({
    addTagTypes: ['constellationResults', 'constellationResult'],
  })
  .injectEndpoints({
    overrideExisting: true,
    endpoints: builder => ({
      getConstellationsResults: builder.query<
        ConstellationResult[],
        Filter<ConstellationResult> | void
      >({
        query: filter => ({
          url: `/constellation-results`,
          method: 'GET',
          params: filter
            ? {
                filter: JSON.stringify(filter),
              }
            : undefined,
        }),
        providesTags: ['constellationResults'],
      }),
      getConstellationsResult: builder.query<
        ConstellationResult,
        { id: number | string; filter?: Filter<ConstellationResult> }
      >({
        query: q => ({
          url: `/constellation-results/${q.id}`,
          method: 'GET',
          params: q.filter
            ? {
                filter: JSON.stringify(q.filter),
              }
            : undefined,
        }),
        providesTags: ['constellationResult'],
      }),
    }),
  });

export const { useGetConstellationsResultsQuery, useGetConstellationsResultQuery } = extendedApi;
